var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',[_c('b-row',{staticClass:"not-found-row",attrs:{"align-h":"center","align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('p',{staticClass:"not-found-text"},[_vm._v("404 Error - Не найдено")]),_c('button',{staticClass:"btn btn-md btn-block btn-black",attrs:{"type":"button"},on:{"click":() => {
              _vm.$router.go(-1);
            }}},[_vm._v(" Назад ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }